
































































































import moment from 'moment'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import ClipboardCopyMixin from '../../../../logic/helpers/ClipboardCopyMixin'
import { atSignedLogin } from '../../../../shared/utils/tgLoginHelpers'
import UserSendMessage from '../../../BotUsers/components/UserSendMessage/UserSendMessage.vue'
import { UserProfile } from '../../../BotUsers/components/Users/types'
import UserMainInfo from '../../../UserMainInfo.vue'
import { ProfileCardHelper } from '../../types'
import ProfileFreeLabelsList from './components/ProfileFreeLabelsList.vue'
import SetUserAttributes from './components/SetUserAttributes.vue'
import StaticInfo from './components/StaticInfo.vue'

@Component({
  data() {
    return {
      isMobile,
      moment,
      atSignedLogin
    }
  },
  components: {
    UserMainInfo,
    UserSendMessage,
    ProfileFreeLabelsList,
    StaticInfo,
    SetUserAttributes
  }
})
export default class ProfileCard extends Mixins(ClipboardCopyMixin) {
  @Prop() helper!: ProfileCardHelper

  @Prop() profile!: UserProfile

  @Emit()
  updateProfile() {
    return null
  }

  profileLabels: Array<{ name: string, id: number }> | null = null

  labels: Array<{ name: string, id: number }> = []

  onGotoUser(id: number) {
    if (this.helper.gotoUser) {
      this.helper.gotoUser(id)
    }
  }

  banUserHandler(): void {
    if (this.profile) {
      if (this.profile.banned) {
        this.helper.unban(this.profile.user_id).then(() => this.profile ? this.profile.banned = !this.profile.banned : null )
      } else {
        this.helper.ban(this.profile.user_id).then(() => this.profile ? this.profile.banned = !this.profile.banned : null )
      }
    }
  }
}
